<template>
  <page>
    <!-- <template slot="header" >
      <div class="container-fluid m-0 pb-0" >
        <div class="row">
          <div class="col-sm-6">
            <h3 class="m-0 text-dark">
              Borracharia - Placas
            </h3>
          </div>
          <div class="col-sm-6">
          </div>
        </div>
      </div>
    </template> -->

    <template slot='content'>
      <!-- <indicadores-resumo></indicadores-resumo> -->

      <!-- <Hr /> -->

      <os-list-placas></os-list-placas>
      <!-- <reloadPage></reloadPage> -->
    </template>
  </page>
</template>

<script>
import Page from '@/components/Page'
import OsListPlacas from '@/components/Borracharia/OsListPlacas'
// import IndicadoresResumo from '@/components/IndicadoresResumo'
// import reloadPage from '../common/reloadPage.vue'

export default {
  components: {
    Page,
    OsListPlacas,
    // reloadPage
  },
  beforeDestroy() {
    clearTimeout(this.timer)
  },
  created () {
    const dsColaborador = this.$store.getters['filial/filial']
    this.$store.dispatch('filial/actionSidebar')
  },

  data() {
    return {
      isSidebarOpen: false,
      breadcrumbItems: [
        {
          text: 'Ordens para atendimento',
          active: true
        }
      ],
      timer: ''
    }
  },
  methods: {
    reloadPage() {
      const host = window.location.pathname;

      this.timer = setTimeout(() => {
        if (host == "/" || host == "/osPreventiva") {
          this.$store.dispatch("os/fetchFromApi", {});
        } else if (host == '/osExterna') {
          this.$store.dispatch('os/fetchFromApiExterna')
        }
        this.reloadPage();
      }, 1000 * 5);
      console.log(this.timer)

    }
  }
}
</script>
